<template>
    <div v-if="currentStep != null && formattedSteps != null">
        <div class="container py-3" v-if="this.formattedSteps != null">
            <div class="step-title col-12">
                <b class="h1 text-secondary my-1 my-sm-3 d-block">{{ this.formattedSteps[currentStep].replace('-', ' ') }}</b>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['steps', 'currentStep', 'size'],
        data() {
            return {
                updatedSteps: this.steps
            }
        },
        created() {
            this.emitter.on('stepsUpdated', data => {
                this.updatedSteps = data;
            });
        },
        computed: {
            formattedSteps: function() {
                var formattedSteps = {};
                var customStepText = '';

                if(this.updatedSteps != null) {
                    _.forEach(this.updatedSteps, function(step, key) {
                        if(step == 'confirm-size') {
                            customStepText = 'Confirm size';
                        }
                        else if(step == 'select-tyres') {
                            customStepText = 'Select tyres';
                        }
                        else if(step == 'choose-fitter') {
                            customStepText = 'Choose a fitter';
                        }
                        else if(step == 'fitted-nationally') {
                            customStepText = 'Fitted nationally';
                        }
                        else if(step == 'booking-details') {
                            customStepText = 'Checkout';
                        }
                        else {
                            customStepText = 'Step ' + (key + 1);
                        }

                        formattedSteps[key + 1] = customStepText;
                    });
                }

                return formattedSteps;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .step-title {
        font-size: 25px;
    }
</style>